import React from "react";
import { useNavigate } from "react-router-dom";
import "./ExerciseCard.css";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowUpRightFromSquare,
  faStar,
  faClock,
} from "@fortawesome/free-solid-svg-icons";
import DefaultImage from "../../../assets/Arriving_In_Presence.png";
import { getGuidanceAttribution } from "../../../utils/guidanceAttribution.js";

export const Exercise = ({
  categoryType,
  titleText,
  summaryText,
  imageurl,
  exerciseURL,
  exerciseDuration,
  internal,
  isFavourited = false,
  creator,
  courtesy,
}) => {
  const title = (titleText || "Title").trim();
  const summary = summaryText || "Practice mindfulness and cultivate awareness.";
  const category = categoryType || "Mindfulness";
  const duration = exerciseDuration || 15;
  const imageLocation = imageurl || DefaultImage;
  const exerciseLocation = exerciseURL || "home";
  const navigate = useNavigate();

  // Resolve external teacher / creator attribution
  const attribution =
    (courtesy && { creator, courtesy }) ||
    getGuidanceAttribution({
      title,
      defaulturl: exerciseLocation,
      creator,
      courtesy,
    });
  const courtesyText = attribution?.courtesy || (creator ? `Courtesy of ${creator}` : null);
  const creatorName = attribution?.creator || (courtesyText ? courtesyText.replace(/^Courtesy of\s+/i, "") : null);

  const formattedDuration =
    typeof duration === "number"
      ? duration % 1 === 0
        ? duration
        : duration.toFixed(1)
      : duration;

  const sendtoExercise = () => {
    navigate("/exercises/" + exerciseLocation);
  };

  return (
    <div className="exercise-card" onClick={sendtoExercise} role="button" tabIndex={0}>
      <div className="exercise-card-media">
        <img
          className="exercise-card-img"
          src={imageLocation}
          alt={title}
          loading="lazy"
          onError={(e) => {
            e.currentTarget.onerror = null;
            e.currentTarget.src = DefaultImage;
          }}
        />

        <div className="exercise-card-badges-top">
          {internal === "no" ? (
            <span className="exercise-badge-external">
              <FontAwesomeIcon
                icon={faArrowUpRightFromSquare}
                style={{ fontSize: "10px", marginRight: "4px" }}
              />
              External
            </span>
          ) : (
            <span />
          )}

          {isFavourited && (
            <span className="exercise-badge-fav" title="Favourited practice">
              <FontAwesomeIcon
                icon={faStar}
                style={{ color: "#EAB308", marginRight: "4px" }}
              />
              Favourite
            </span>
          )}
        </div>

        <div className="exercise-card-badge-duration">
          <FontAwesomeIcon
            icon={faClock}
            style={{ fontSize: "10px", marginRight: "4px" }}
          />
          <span>{formattedDuration} min</span>
        </div>
      </div>

      <div className="exercise-card-body">
        <div className="exercise-card-meta">
          <span className="exercise-category-pill">{category}</span>
          {courtesyText && (
            <span className="exercise-courtesy-pill" title={courtesyText}>
              {courtesyText}
            </span>
          )}
        </div>

        <h3 className="exercise-card-title" title={title}>
          <span>{title}</span>
          {internal === "no" && (
            <FontAwesomeIcon
              icon={faArrowUpRightFromSquare}
              className="exercise-title-ext-icon"
              title="External guidance"
            />
          )}
        </h3>

        <p className="exercise-card-summary">{summary}</p>

        <div className="exercise-card-footer">
          {courtesyText ? (
            <div className="exercise-card-courtesy" title={courtesyText}>
              <span className="courtesy-tag-prefix">Courtesy of </span>
              <span className="courtesy-tag-name">{creatorName}</span>
            </div>
          ) : (
            <div className="exercise-card-courtesy-placeholder" />
          )}

          <span className="exercise-cta-link">
            <span>Start Practice</span>
            <span className="exercise-cta-arrow">→</span>
          </span>
        </div>
      </div>
    </div>
  );
};